import React from 'react'
import PropTypes from 'prop-types'

import { useFetchPopularAreass } from './popularAreasSearchApis'
import PopularAreasSearch from './index'


const PopularAreasSearchApiContainer = ({
  showPopSearches,
  onSuggestionSelect,
}) => {
  // apis
  const { data: popularAreas } = useFetchPopularAreass()

  return (
    <PopularAreasSearch
      popularAreas={popularAreas}
      showPopSearches={showPopSearches}
      onSuggestionSelect={onSuggestionSelect}
    />
  )
}


PopularAreasSearchApiContainer.propTypes = {
  showPopSearches: PropTypes.bool,
  onSuggestionSelect: PropTypes.func,
}

export default PopularAreasSearchApiContainer
